export default {
	title: 'Configuración de Informe Mensual',
	actions: {
		add: 'Añadir',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminación por Lote',
		save: 'Guardar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	messages: {
		deleteSuccess: 'Eliminación exitosa',
		actionSuccess: 'Operación exitosa'
	},
	labels: {
		monthReportConfig: 'Configuración de Informe Mensual'
	},
	buttons: {
		add: 'Añadir',
		batchDelete: 'Eliminación por Lote',
		edit: 'Editar',
		delete: 'Eliminar'
	},
	table: {
		projectName: 'Nombre del Proyecto',
		executionMode: 'Modo de Ejecución',
		action: 'Acción'
	},
	form: {
		placeholder: {
			projectName: 'Nombre del Proyecto',
			executionMode: 'Modo de Ejecución'
		},
		selectProject: 'Por favor, seleccione el proyecto propiedad',
		selectExecutionMode: 'Por favor, seleccione el modo de ejecución'
	},
	config: {
		gridLayout: 'Diseño de Cuadrícula',
		ownedProject: 'Proyecto Propiedad',
		executionMode: 'Modo de Ejecución',
		day: 'Día',
		week: 'Semana',
		month: 'Mes'
	},
	dialog: {
		add: 'Añadir',
		update: 'Editar'
	}
}
